import { subclass } from '@arcgis/core/core/accessorSupport/decorators';
import type { ThemeColor } from '../../jmkw/theme-color.type';
import { ThemeAwareMixin } from './theme-aware.mixin';
import { JepVectorTileLayer, JepFeatureLayer } from './jep-arcgis.types';
import type {
  JepVectorTileLayerProperties,
  JepFeatureLayerProperties
} from './jep-arcgis.types';

export type ThemeAwareVectorTileLayerProperties = JepVectorTileLayerProperties;

@subclass('jmkw.layers.ThemeAwareVectorTileLayer')
export class ThemeAwareVectorTileLayer extends ThemeAwareMixin(
  JepVectorTileLayer
) {
  constructor(properties?: ThemeAwareVectorTileLayerProperties) {
    super(properties);
  }
  protected updateLayerStyles(theme: ThemeColor): void {
    if (typeof (this as any).updateVectorStyles === 'function') {
      (this as any).updateVectorStyles(theme, this.visible);
    }
  }
}

export type ThemeAwareFeatureLayerProperties = JepFeatureLayerProperties;

@subclass('jmkw.layers.ThemeAwareFeatureLayer')
export class ThemeAwareFeatureLayer extends ThemeAwareMixin(JepFeatureLayer) {
  constructor(properties?: ThemeAwareFeatureLayerProperties) {
    super(properties);
  }
  protected updateLayerStyles(theme: ThemeColor): void {
    if (typeof (this as any).updateFeatureStyles === 'function') {
      (this as any).updateFeatureStyles(theme);
    }
  }
}
